"use strict";
// component-wasThisHelpful.js
(function ($) {
    function wasThisHelpful() {
        $(".wasThisHelpful__actions a").click(function (e) {
            e.preventDefault();
            $(this).closest('.wasThisHelpful').find('.wasThisHelpful__body').hide();
            $(this).closest('.wasThisHelpful').find('.wasThisHelpful__msg').show();
            $(this).closest('.wasThisHelpful').delay(1500).animate({
                opacity: 0
            }, 300, function () {
                $(this).slideUp();
            });
        });
    }
    wasThisHelpful();
})(jQuery);
